// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d1c88ffd","453":"904a2165","455":"489602df","970":"389b7d35"}[chunkId] + ".chunk.js";
};